<template>
  <div
    class="content"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <div class="header-tips">申请后我们会尽快与您联系，并审核您的店长身份</div>
    <van-field
      v-model="info.shopName"
      required
      colon
      right-icon="arrow"
      disabled
      label="绑定社区"
      placeholder="请选择您居住的小区"
    >
      <template #button>
        <router-link
          to="applyCommunity"
          class="overlap"
        ></router-link>
      </template>
    </van-field>
    <van-field
      v-model.trim="info.name"
      required
      colon
      label="姓名"
      maxlength="10"
      placeholder="请输入真实姓名"
      :formatter="formatter"
    />
    <van-field
      v-model.trim="info.mobile"
      type="number"
      required
      colon
      label="手机号"
      maxlength="11"
      placeholder="请输入您的联系方式"
    />
    <van-field
      v-model.trim="info.address"
      required
      colon
      label="自提点"
      maxlength="20"
      placeholder="例如:东门A座1007"
    />
    <div class="address-tips">提示:不要输入省市区，输入提货具体楼层，例如20栋102号</div>
    <div
      class="van-cell van-field"
      style="flex-wrap: wrap"
    >
      <div class="van-cell__title van-field__label">
        <span>我的优势:</span>
      </div>
      <div class="van-cell__value van-field__value van-cell__textarea van-hairline--surround">
        <div>
          <textarea
            rows="2"
            v-model.trim="info.remark"
            placeholder="填写您成为社区店长的优势，可以增加审核通过率哦~"
            class="van-field__control"
            maxlength="200"
          ></textarea>
        </div>
        <div class="van-field__word-limit">
          <span class="van-field__word-num">{{info.remark.length}}</span>/200
        </div>
      </div>
    </div>
    <!-- <div
      class="van-cell van-field"
      style="flex-wrap: wrap"
    >
      <div
        class="van-cell__title van-field__label"
        style="width: auto"
      >
        <span>上传身份证</span>
      </div>
      <div class="van-cell__value van-field__value van-cell__tips">
        <div>非必填</div>
      </div>
      <div class="idcard-back">
        <van-uploader
          name="cardUp"
          :after-read="afterRead"
          v-model="cardUpList"
          max-count="1"
          preview-size="100%"
          :upload-icon="require('../../assets/img/idcard_front.png')"
          :max-size="3686.4 * 1024"
          @oversize="onOversize"
        >
        </van-uploader>
      </div>
      <div class="idcard-back">
        <van-uploader
          name="cardDown"
          :after-read="afterRead"
          v-model="cardDownList"
          max-count="1"
          preview-size="100%"
          :upload-icon="require('../../assets/img/idcard_back.png')"
          :max-size="3686.4 * 1024"
          @oversize="onOversize"
        >
        </van-uploader>
      </div>
    </div>
    <div
      class="van-cell van-field"
      style="flex-wrap: wrap"
    >
      <div
        class="van-cell__title van-field__label"
        style="width: auto"
      >
        <span>上传手持身份证照片</span>
      </div>
      <div class="van-cell__value van-field__value van-cell__tips">
        <div>非必填</div>
      </div>
      <div class="idcard-take">
        <van-uploader
          name="cardTake"
          :after-read="afterRead"
          v-model="cardTakeList"
          max-count="1"
          preview-size="100%"
          :upload-icon="require('../../assets/img/idcard_take.png')"
          :max-size="3686.4 * 1024"
          @oversize="onOversize"
        >
        </van-uploader>
      </div>
    </div> -->
    <van-button
      class="btn"
      text="申请开店"
      block
      @click="applySubmit"
    />
  </div>
</template>

<script>
import { applySubmit, uploadImageBase64 } from "@/api/join";
export default {
  data() {
    return {
      info: {
        name: "",
        type: "1",
        mobile: this.$store.getters.phone,
        remark: "",
        address: "",//地址
        identityCardUpImage: "",//身份证正面扫描件
        identityCardDownImage: "",//手机号身份证背面扫描件
        handIdentityCardImage: "",//手持身份证照片
      },
      cardUpList: [],
      cardDownList: [],
      cardTakeList: [],
    };
  },
  methods: {
    formatter(value) {
      // 只能输入中文
      return value.replace(/[^\u4E00-\u9FA5]/g, '');
    },
    onOversize() {
      this.$toast("图片大小不能超过3.6M");
    },
    afterRead(file, detail) {
      file.status = "uploading";
      file.message = "上传中...";
      let self = this;
      let files = file.file;
      let reader = new FileReader();
      // 将图片2将转成 base64 格式
      reader.readAsDataURL(files);
      // 读取成功后的回调
      reader.onloadend = function () {
        let result = this.result;
        let img = new Image();
        img.src = result;
        self.postImg(file, detail, this.result);
      }
    },
    postImg(file, detail, image) {
      let base64 = image.slice(image.indexOf(",") + 1, image.length);
      let obj = {
        fileContent: base64,
      };
      uploadImageBase64(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          file.status = "done";
          file.message = "上传成功";
          if (detail.name == "cardUp") {
            this.info.identityCardUpImage = res.content.path;
          } else if (detail.name == "cardDown") {
            this.info.identityCardDownImage = res.content.path;
          } else {
            this.info.handIdentityCardImage = res.content.path;
          }
        } else {
          file.status = "failed";
          file.message = "上传失败";
        }
      });
    },
    applySubmit() {
      if (this.info.shopName == undefined || this.info.shopName == "") {
        this.$toast("请选择您居住的小区");
        return;
      } else if (this.info.name == undefined || this.info.name == "") {
        this.$toast("请输入真实姓名");
        return;
      } else if (this.info.mobile == undefined || this.info.mobile == "") {
        this.$toast("请输入您的联系方式");
        return;
      } else if (this.info.address == undefined || this.info.address == "") {
        this.$toast("请输入您的自提地址");
        return;
      } else if (this.cardUpList.length) {
        if (this.cardUpList[0].status == "uploading") {
          this.$toast("身份证上传中，请稍等");
          return;
        }
      } else if (this.cardDownList.length) {
        if (this.cardDownList[0].status == "uploading") {
          this.$toast("身份证上传中，请稍等");
          return;
        }
      } else if (this.cardTakeList.length) {
        if (this.cardTakeList[0].status == "uploading") {
          this.$toast("身份证上传中，请稍等");
          return;
        }
      }
      applySubmit(this.info).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$router.replace({
            name: "applySuccess",
            path: "/applySuccess",
            params: {
              info: JSON.stringify(this.info),
            },
          });
        } else if (res.appStatus.errorCode == 5238) {
          this.$dialog.alert({
            title: "提交失败",
            message: "该社区已有社区店长<br/>请重新选择社区",
            showConfirmButton: "好的",
            confirmButtonColor: "#1D1D1D",
          });
        }
      });
    },
  },
  watch: {
    "$store.getters.communityData": {
      handler(newV, oldV) {
        this.$set(this.info, "shopName", newV.shopName);
        this.$set(this.info, "communityId", newV.communityId);
      },
    },
    $route: {
      handler(newV, oldV) {
        if (newV.params.info) {
          let applyInfo = JSON.parse(newV.params.info);
          for (let key in applyInfo) {
            this.$set(this.info, key, applyInfo[key]);
          }
          if (this.info.identityCardUpImage != "") {
            this.cardUpList.push({ url: this.imgPrex + this.info.identityCardUpImage });
          }
          if (this.info.identityCardDownImage != "") {
            this.cardDownList.push({ url: this.imgPrex + this.info.identityCardDownImage });
          }
          if (this.info.handIdentityCardImage != "") {
            this.cardTakeList.push({ url: this.imgPrex + this.info.handIdentityCardImage });
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 30px 15px 80px;
  .header-tips {
    position: fixed;
    top: 44px;
    left: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    background-color: #ffe9d5;
    z-index: 1000;
  }
  .van-cell__tips {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
    text-align: left;
  }
  .van-cell__textarea {
    flex: 0 0 315px;
    margin-top: 15px;
    padding: 10px;
    textarea {
      height: 85px;
      font-size: 12px;
    }
  }
  .van-cell__textarea[class*="van-hairline"]::after {
    border-width: 1.04px !important;
    border-color: #b4b4b4;
    border-radius: 10px;
  }
  .overlap {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 9999;
  }
  .idcard-back,
  .idcard-take {
    margin: 10px 46.5px 0;
    flex-basis: 100%;
  }
  .idcard-back {
    height: 152px;
    &:nth-of-type(2n + 1) {
      margin-top: 16px;
    }
  }
  .idcard-take {
    height: 160px;
  }
}
.cover {
  .header-tips {
    top: 0;
  }
}
.van-cell {
  padding: 13px 0 13px 11px;
  font-size: 15px;
  color: #333333 !important;
  &:not(:last-child)::after {
    left: 0;
  }
  &:nth-child(n + 7)::after {
    opacity: 0;
  }
  .van-field__word-limit {
    color: #b4b4b4;
  }
}
.van-cell--required::before {
  left: 0;
  font-weight: 800;
  color: #ff2727;
}
.btn {
  width: 355px;
  height: 50px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  background: linear-gradient(
    90deg,
    rgba(251, 106, 74, 1) 0%,
    rgba(255, 8, 8, 1) 100%
  );
  font-size: 19px;
  color: #ffffff;
  border-width: 0;
  border-radius: 25px;
}
.address-tips {
  height: 27px;
  line-height: 27px;
  font-size: 12px;
  color: #ff2727;
}
</style>
<style scoped>
.content >>> .van-field__label {
  width: 75px;
  margin-right: 0;
}
.content >>> .van-field--disabled .van-field__label {
  color: initial;
}
.content >>> .van-uploader__preview {
  width: 241px;
  height: 152px;
  margin: 0;
}
.idcard-back >>> .van-uploader__upload,
.idcard-take >>> .van-uploader__upload {
  margin: 0;
}
.idcard-back >>> .van-icon__image,
.idcard-take >>> .van-icon__image {
  width: 100%;
  height: 100%;
  display: block;
}
</style>